// packages
import cx from 'classnames';
import { entries } from 'd3-collection';
import { apnumber, intcomma } from 'journalize';
import { Component, h } from 'preact';

// components
import PartyPill from './PartyPill';

interface Props {
  candidates: { [key: string]: any };
  counties: { [key: string]: any };
  visibleCandidates?: number;
  visibleRows?: number;
}

interface State {
  viewAll: boolean;
}

class CountyTable extends Component<Props, State> {
  constructor() {
    super();

    this.state = { viewAll: false };

    this.onViewAllToggle = this.onViewAllToggle.bind(this);
  }

  onViewAllToggle() {
    this.setState((prevState: State) => ({
      viewAll: !prevState.viewAll,
    }));
  }

  render() {
    const { candidates, counties, visibleCandidates, visibleRows } = this.props;
    const { viewAll } = this.state;

    const allowedVisibleCandidates = candidates.slice(0, visibleCandidates);
    const candidateIdOrder = allowedVisibleCandidates.map(
      (candidate: any) => candidate.id
    );
    const numberOfCounties = counties.length;

    return (
      <div class="county-results">
        <table class="dv-table dv-table--small">
          <thead>
            <tr>
              <th scope="col">County</th>
              {allowedVisibleCandidates.map((candidate: any) => (
                <th key={candidate.id} scope="col" class="text-right">
                  <PartyPill party={candidate.party} />{' '}
                  {candidate.ballot_sort_name}
                </th>
              ))}
              <th scope="col" class="text-right">
                Pct.
                <span class="candidate__pct-symbol always-hidden">%</span>
              </th>
            </tr>
          </thead>
          <tbody>
            {counties
              .sort((a, b) => b.total_votes - a.total_votes)
              .map((county, idx) => {
                const leadingCandidateId = entries(county.results).sort(
                  (a, b) => b.value - a.value
                )[0].key;

                const percentClass = cx('candidate__pct-symbol', {
                  'always-hidden': idx !== 0,
                });

                return (
                  <tr
                    key={county.fips}
                    class={!viewAll && visibleRows < idx + 1 && 'display-none'}
                  >
                    <th scope="row">{county.county}</th>
                    {candidateIdOrder.map(id => {
                      const isLeadingCandidate = id === leadingCandidateId;

                      const className = cx('text-right', {
                        'font-weight-bold': isLeadingCandidate,
                      });

                      return (
                        <td key={id} class={className}>
                          {intcomma(county.results[id])}
                        </td>
                      );
                    })}
                    <td class="text-right">
                      {(
                        (county.precincts_reporting / county.total_precincts) *
                        100
                      ).toFixed(1)}
                      <span class={percentClass}>%</span>
                    </td>
                  </tr>
                );
              })}
          </tbody>
        </table>

        {numberOfCounties > visibleRows && (
          <div class="text-center">
            <button class="button--toggle" onClick={this.onViewAllToggle}>
              {`View ${
                viewAll ? 'fewer' : `all ${apnumber(numberOfCounties)}`
              } counties`}
              {viewAll ? (
                <svg class="icon icon-angle-up">
                  <use xlinkHref="#icon-angle-up" />
                </svg>
              ) : (
                <svg class="icon icon-angle-down">
                  <use xlinkHref="#icon-angle-down" />
                </svg>
              )}
            </button>
          </div>
        )}
      </div>
    );
  }
}

CountyTable.defaultProps = {
  visibleCandidates: 2,
  visibleRows: 5,
};

export default CountyTable;
